import { API_BASE, describeFailure } from './api';

/** Triggers a browser download of one of the server's export formats without leaving the page. */
export async function downloadMissionExport(missionId: string, format: 'json' | 'csv' | 'pdf', filename: string): Promise<void> {
  const response = await fetch(`${API_BASE}/missions/${missionId}/export?format=${format}`);
  if (!response.ok) {
    const { message } = await describeFailure(response);
    throw new Error(message);
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoking in the same task as click() can cancel the download before the
  // browser has read the blob; hand the URL back on a later turn instead.
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
